module.exports = "/static/assets/c68c293bc65d68238f912074b1fd1386.gif";